(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('CardPrefixConfig', CardPrefixConfig);

    CardPrefixConfig.$inject = ['$resource', 'DateUtils'];

    function CardPrefixConfig ($resource, DateUtils) {
        var resourceUrl =  'api/card-prefix-configs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'updateAll': { url: 'api/card-prefix-configs/update-all', method: 'PUT', isArray: true }
        });
    }
})();
